import { $themeBreakpoints } from '@themeConfig'
import { 
  getAllNotifications, getNotificationsSetNotif
} from '@/api/notifications'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    notifications: [],
    notifications2: [],
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_ALL_NOTIFICATIONS(state, val) {
      state.notifications = val
    },
    SET_ALL_NOTIFICATIONS2(state, val) {
      state.notifications2 = val
    },
  },
  actions: {
    FETCH_ALL_NOTIFICATIONS({ commit }, data) {
      return new Promise((reslove, reject) => {
        getAllNotifications(data)
          .then(res => {
            commit('SET_ALL_NOTIFICATIONS', res.data)
            reslove(res.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    FETCH_ALL_NOTIFICATIONS2({ commit }, data) {
      return new Promise((reslove, reject) => {
        getAllNotifications(data)
          .then(res => {
            commit('SET_ALL_NOTIFICATIONS2', res.data)
            reslove(res.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    FETCH_NOTIFICATIONS_SET_NOTIF({ commit }, data) {
      return new Promise((reslove, reject) => {
        getNotificationsSetNotif(data)
          .then(res => {
            // commit('SET_ALL_NOTIFICATIONS', res.data)
            reslove(res.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
